import * as Sentry from '@sentry/react-router';
import { StrictMode, startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';
import { env } from './env';
import { initLiff } from './lib/liff';
import { initLiffMock } from './lib/liff.mock';
import { enableMocking } from './lib/msw';

const setupLiff = env.VITE_LIFF_MOCK ? initLiffMock : initLiff;

/** @see https://docs.sentry.io/platforms/javascript/guides/react-router/configuration/options/ */
Sentry.init({
  dsn: env.VITE_SENTRY_DSN,
  enabled: env.VITE_SENTRY_ENABLED,
  environment: env.VITE_APP_ENV,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.captureConsoleIntegration(),
    Sentry.httpClientIntegration(),
  ],
  tracesSampleRate: env.VITE_SENTRY_TRACES_SAMPLE_RATE,
  replaysSessionSampleRate: env.VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE,
  replaysOnErrorSampleRate: env.VITE_SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE,
});

setupLiff()
  .then(() =>
    enableMocking(env.VITE_API_MOCK).then(() =>
      startTransition(() => {
        hydrateRoot(
          document,
          <StrictMode>
            <HydratedRouter />
          </StrictMode>,
        );
      }),
    ),
  )
  .catch((e: Error) => {
    // NOTE: 誤った LIFF ID の指定など設定ミスによるエラーが主なので簡易な表示に留める
    console.error(e);
    alert(`${e.name}: ${e.message}`);
  });
